/**
 * Maps a document file to the short, all-caps label shown in "Type" /
 * "File Type" columns across the documents pages (e.g. "PDF", "JPG").
 *
 * We prefer the file extension because that's what users recognize at a
 * glance; the MIME group is only a fallback for files that lack an
 * extension. The set of recognized types intentionally mirrors
 * `DOCUMENT_FILE_ALLOWED_MIME_TYPES` in `mapistry-shared`.
 */
export function fileTypeFromMime(mime: string, fallbackName?: string): string {
  if (fallbackName?.includes('.')) {
    const ext = fallbackName.slice(fallbackName.lastIndexOf('.') + 1);
    if (ext && ext.length > 0) {
      return ext.toUpperCase();
    }
  }
  if (mime.includes('pdf')) return 'PDF';
  if (mime.includes('word')) return 'DOC';
  if (mime.includes('excel') || mime.includes('spreadsheet')) return 'XLS';
  if (mime.includes('csv')) return 'CSV';
  if (mime.includes('jpeg')) return 'JPG';
  if (mime.includes('png')) return 'PNG';
  if (mime.startsWith('video/')) return 'VIDEO';
  return mime;
}
